import { CollectibleElastic_Schema } from "@/services/collectibles/elastic";
import { CategoryId_Schema } from "@/services/collection/categories/categoriesSchema";
import { ApiResponse_ImageNoId_Schema } from "@/services/images";
import { PriceNumericOrEmpty_Schema } from "@/services/prices/priceSchema";
import { DateString_Schema } from "@/utilities";
import { z } from "zod";

export const AiIdentificationId_Schema = z.uuid();

export const AiIdentification_Schema = z.object({
  id: AiIdentificationId_Schema,
  categoryId: CategoryId_Schema,
  name: z.string(),
  priceFrom: PriceNumericOrEmpty_Schema,
  priceTo: PriceNumericOrEmpty_Schema,
  images: z.array(ApiResponse_ImageNoId_Schema),
  description: z.string().nullable(),
  confidenceScore: z.number(),
  collectible: CollectibleElastic_Schema.nullable().optional(), // optional() - older identifications may not have a collectible

  // Older AI identification versions may include additional fields (e.g. parameters).
});

export const AiIdentificationSummary_Schema = z.object({
  id: AiIdentificationId_Schema,
  categoryId: CategoryId_Schema,
  name: z.string(),
  datetime: DateString_Schema,
  priceFrom: PriceNumericOrEmpty_Schema,
  priceTo: PriceNumericOrEmpty_Schema,
  images: z.array(ApiResponse_ImageNoId_Schema),
});
